var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainContent"},[_c('h2',[_vm._v("Ups! Página no encontrada")]),_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.$router.push({name: 'home'})}}},[_vm._v("Volver al curso")])])}
var staticRenderFns = []

export { render, staticRenderFns }